import { IFigurant, IFiscal, IPet, IVehicle } from 'models';

export enum SRC_TYPES {
  CLIMBED = 'CLIMBED',
  LICENSE = 'LICENSE',
  SEARCH = 'SEARCH',
}

export type ReturnValueFunc = { label: string; value?: string };

type MountFigurantFunction = (item: IFigurant) => ReturnValueFunc[];
type MountFiscalFunction = (item: IFiscal) => ReturnValueFunc[];
type MountAnimalFunction = (item: IPet) => ReturnValueFunc[];
type MountVehicleFunction = (item: IVehicle) => ReturnValueFunc[];

export type MountFunctionsMap = {
  1: MountFigurantFunction;
  2: MountVehicleFunction;
  3: MountAnimalFunction;
  4: MountFiscalFunction;
  5: MountFigurantFunction;
  8: MountFigurantFunction;
  9: MountFigurantFunction;
  10: MountFigurantFunction;
};

export type KeySrcTypes = keyof typeof SRC_TYPES;
